import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ChartCard from './ChartCard';

interface PeriodLineChartProps {
  data: Array<{
    data: string;
    criados?: number;
    assinados?: number;
    ativados?: number;
    contratosCriados?: number;
    contratosAssinados?: number;
    contratosAtivados?: number;
  }>;
  title?: string;
  subtitle?: string;
}

const PeriodLineChart: React.FC<PeriodLineChartProps> = ({ 
  data, 
  title = 'Evolução Temporal',
  subtitle 
}) => {
  const formatDate = (dateStr: string) => {
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    } catch {
      return dateStr;
    }
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'rgba(44, 62, 80, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '12px',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 600 }}>{formatDate(label)}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ margin: '4px 0', color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  // Normalizar dados para usar os mesmos nomes de propriedade
  const normalizedData = data.map(item => ({
    data: item.data,
    Criados: item.criados ?? item.contratosCriados ?? 0,
    Assinados: item.assinados ?? item.contratosAssinados ?? 0,
    Ativados: item.ativados ?? item.contratosAtivados ?? 0,
  }));

  return (
    <ChartCard title={title} subtitle={subtitle}>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={normalizedData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
          <XAxis 
            dataKey="data" 
            stroke="rgba(255, 255, 255, 0.6)"
            tick={{ fill: 'rgba(255, 255, 255, 0.8)' }}
            tickFormatter={formatDate}
          />
          <YAxis stroke="rgba(255, 255, 255, 0.6)" tick={{ fill: 'rgba(255, 255, 255, 0.8)' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="Criados" 
            stroke="#3498db" 
            strokeWidth={2}
            dot={{ fill: '#3498db', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line 
            type="monotone" 
            dataKey="Assinados" 
            stroke="#f39c12" 
            strokeWidth={2}
            dot={{ fill: '#f39c12', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line 
            type="monotone" 
            dataKey="Ativados" 
            stroke="#2ecc71" 
            strokeWidth={2}
            dot={{ fill: '#2ecc71', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default PeriodLineChart;

